import React from "react";

import closeIcon from "../images/icon-close.svg";

const FileToUpload = (props) => {
  var isLoading = props.isLoading;

  return (
    <div className="file-label">
      <p className="file-name">{props.file.FileName}</p>
      <div className="progress-control">
        {isLoading && (
          <div className="progress-bar mr-3">
            <div
              className="progress-line"
              style={{ width: props.progress + "%" }}
            />
          </div>
        )}
        <img src={closeIcon} alt="" onClick={() => props.onClick()} />
      </div>
    </div>
  );
};

export default FileToUpload;
